import "./App.css";
import Hyperspeed from "./components/Hyperspeed/Hyperspeed";
import ColorBends from "./components/ColorBends/ColorBends";
import { useState, useEffect } from "react";
import {
  Navbar,
  Home,
  Socials,
  Email,
  About,
  Experience,
  Builds,
  Others,
  Contact,
  Preloader,
} from "./components";

function App() {
  const [preloader, setPreloader] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setPreloader(false);
    }, 2150);
  });

  useEffect(() => {
    document.body.style.overflowY = preloader ? "hidden" : "scroll";
  }, [preloader]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App">
      <div className="hyperspeed-background">
        {/* <ColorBends
          colors={["#ff5c7a", "#8a5cff", "#00ffd1"]}
          rotation={30}
          speed={0.3}
          scale={1.2}
          frequency={1.4}
          warpStrength={1.2}
          mouseInfluence={0.8}
          parallax={0.6}
          noise={0.08}
          transparent
        /> */}
      </div>
      {preloader && <Preloader />}
      {!preloader && (
        <div className="app-content">
          <Navbar />
          <Home />
          <Socials />
          <Email />
          <About />
          <Experience />
          <Builds />
          <Others />
          <Contact />
        </div>
      )}
    </div>
  );
}

export default App;
